import { render, staticRenderFns } from "./EditMetaDataModal.vue?vue&type=template&id=0087421a&"
import script from "./EditMetaDataModal.vue?vue&type=script&lang=js&"
export * from "./EditMetaDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports